var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.636 12H20.91C23.168 12 25 13.791 25 16C25 18.209 23.17 20 20.909 20H17.636V18.4H20.909C22.264 18.4 23.364 17.326 23.364 16C23.364 14.674 22.265 13.6 20.909 13.6H17.636V12ZM14.364 20H11.09C8.832 20 7 18.209 7 16C7 13.791 8.83 12 11.09 12H14.364V13.6H11.091C9.736 13.6 8.636 14.674 8.636 16C8.636 17.326 9.735 18.4 11.09 18.4H14.364V20ZM20.091 15.2H11.909V16.8H20.091V15.2Z",
    fill: "#647FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.f7a4ed26d6a42259d4cdaceab2caa30e.svg";
export { ForwardRef as ReactComponent };